module.exports = __webpack_public_path__ + "img/chevron-up.d3050840.svg";